<div class="d-flex flex-column flex-md-row">
  <!--<div class="d-flex flex-md-column flex-shrink-0 side-bar">

  </div>-->
  <div class="flex-grow-1 overflow-auto p-4">
    <router-outlet></router-outlet>
  </div>
</div>
